import { render, staticRenderFns } from "./SelectTask.vue?vue&type=template&id=a200950c&scoped=true&"
import script from "./SelectTask.vue?vue&type=script&lang=ts&"
export * from "./SelectTask.vue?vue&type=script&lang=ts&"
import style0 from "./SelectTask.vue?vue&type=style&index=0&id=a200950c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a200950c",
  null
  
)

export default component.exports